import { Moment } from "moment-timezone";
import CalendarScheduleSlotModel from "./CalendarScheduleSlotModel";
import SessionModel, { SessionStates } from "../api/models/SessionModel";
import ScheduledSession from "./ScheduledSession";

export type ScheduledSessionCollectionByDisplayStatus = {
  [SessionStates.coming]: ScheduledSessionCollection;
  [SessionStates.in_progress]: ScheduledSessionCollection;
  [SessionStates.scheduled]: ScheduledSessionCollection;
};

export default class ScheduledSessionCollection {
  collection: ScheduledSession[];

  constructor(arg: ScheduledSession[]) {
    this.collection = arg;
  }

  addSession(session: ScheduledSession) {
    this.collection.push(session);
  }

  toSessionModel(): SessionModel[] {
    return this.collection.map((item) => item.toSessionModel());
  }

  createGroupsByDisplayStatus(
    referenceDateTime: Moment
  ): ScheduledSessionCollectionByDisplayStatus {
    const groups = {
      [SessionStates.coming]: new ScheduledSessionCollection([]),
      [SessionStates.in_progress]: new ScheduledSessionCollection([]),
      [SessionStates.scheduled]: new ScheduledSessionCollection([]),
    };

    this.collection.forEach((session) => {
      if (session.isInProgress(referenceDateTime)) {
        groups[SessionStates.in_progress].addSession(session);
      } else if (session.isUpcomingNext(referenceDateTime)) {
        groups[SessionStates.coming].addSession(session);
      } else {
        groups[SessionStates.scheduled].addSession(session);
      }
    });

    return groups;
  }
}
